import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListContactListRequest extends IBaseRequest {
    systemId?:             string;
    filterName?:           string;
    offset?:               number;
    limit?:                number;
    treeHandle?:           string;
    useDefaultTreeHandle?: string;
    list?:                 string;
}

export class ListContactListRequest extends BaseRequest implements IListContactListRequest {
    public systemId?:             string;
    public filterName?:           string;
    public offset?:               number;
    public limit?:                number;
    public treeHandle?:           string;
    public useDefaultTreeHandle?: string;
    public list?:                 string;

    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.systemId = otherOptions.systemId;
        this.filterName = otherOptions.filterName;
        this.offset = otherOptions.offset;
        this.limit = otherOptions.limit;
        this.treeHandle = otherOptions.treeHandle;
        this.useDefaultTreeHandle = otherOptions.useDefaultTreeHandle;
        this.list = otherOptions.list;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.systemId, 'systemId');
        parameters += this.makeNode(this.filterName, 'filterName');
        parameters += this.makeNode(this.offset, 'offset');
        parameters += this.makeNode(this.limit, 'limit');
        parameters += this.makeNode(this.treeHandle, 'treeHandle');
        parameters += this.makeNode(this.useDefaultTreeHandle, 'useDefaultTreeHandle');
        parameters += this.makeNode(this.list, 'list');
        
        return super.wrapperXml('ListContactList', parameters);
    }
}
